import { CampaignTab } from './CampaignTab';

type CampaignTabsProps = {
  title: string;
  subtitle: string;
  tabs: any[];
  activeSlug?: string | null;
  NextLink: any;
  basePath?: string;
};

export const CampaignTabs = ({
  title,
  subtitle,
  tabs,
  activeSlug = 'none',
  NextLink,
  basePath = '/kampanje',
}: CampaignTabsProps) => {
  return (
    <div className="grid grid-cols-2 gap-2 md:grid-cols-[repeat(auto-fit,132px)]">
      <CampaignTab
        tab={{ title, subtitle, tabSlug: { current: '/' } }}
        active={activeSlug === 'kampanje'}
        NextLink={NextLink}
        basePath={basePath}
      />
      {tabs.map((tab, index) => {
        return (
          <CampaignTab
            key={index}
            tab={tab}
            active={activeSlug === tab.tabSlug.current}
            NextLink={NextLink}
            basePath={basePath}
          />
        );
      })}
    </div>
  );
};
